module.exports = __webpack_public_path__ + "img/lantern.73ba42fe.webp";